import Environment from '../../Enviroment';

const limitedAccessModalImageUrl = `${Environment.feOrigin}/images/limited-access-prompt.svg`;

export const preLoadedImagesList = [limitedAccessModalImageUrl];
